import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import OzLoadingSpinnerWithCheckmark from '@@/library/v4/components/OzLoadingSpinnerWithCheckmark.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from '@@/library/v4/components/OzPlainButton.vue'
import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteboardUploadStatusPill',
  props: {
    progress: { default: null },
    done: { type: Boolean, default: false },
    fileName: { default: '' },
    canvasWidth: { default: window.innerWidth },
    type: { default: 'file' }
  },
  emits: ['clear', 'cancel'],
  setup(__props: any, { expose, emit }) {

const props = __props as { progress: number | null, done: boolean, fileName: string, canvasWidth: number, type: 'file' | 'link' };



const isUploadDone = computed(() => props.done)
const isTransformedToCheckmark = ref(false)
const isHidden = ref(false)
const isPeeking = ref(false)

const progressingText = computed(() => {
  if (props.type === 'file') {
    return __('Uploading')
  }
  return __('Posting')
})

const doneText = computed(() => {
  if (props.type === 'file') {
    return __('Uploaded')
  }
  return __('Posted')
})

function handleTransformedToCheckmark() {
  isTransformedToCheckmark.value = true
}

watch(isUploadDone, (newValue) => {
  if (!newValue) {
    isTransformedToCheckmark.value = false
  }
})
watch(isTransformedToCheckmark, (newValue) => {
  if (newValue) {
    setTimeout(() => {
      hide()
    }, 3000)
    setTimeout(() => {
      emit('clear')
    }, 4500)
  }
})
function hide() {
  isHidden.value = true
}

const stopPeekingTimer = ref<ReturnType<typeof setTimeout> | null>(null)
function peek() {
  // N.B. This is commented out because it's not used in the current implementation.
  // isPeeking.value = true
  // if (stopPeekingTimer.value) {
  //   clearTimeout(stopPeekingTimer.value)
  // }
}
function stopPeeking() {
  stopPeekingTimer.value = setTimeout(() => {
    isPeeking.value = false
  }, 1000)
}

function cancelStoppingPeeking() {
  if (stopPeekingTimer.value) {
    clearTimeout(stopPeekingTimer.value)
  }
}
expose({
  stopPeeking,
  cancelStoppingPeeking,
})

return { __sfc: true,props, emit, isUploadDone, isTransformedToCheckmark, isHidden, isPeeking, progressingText, doneText, handleTransformedToCheckmark, hide, stopPeekingTimer, peek, stopPeeking, cancelStoppingPeeking, __, OzLoadingSpinnerWithCheckmark, OzPlainButton, OzPlainButtonColorScheme, OzPlainButtonSizePreset }
}

})